module.exports = __webpack_public_path__ + "img/add-debit-card.29462355.jpg";